import _toConsumableArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { useQueue, randomId } from '@mantine/hooks';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

function useNotificationsState(_ref) {
  var limit = _ref.limit;

  var _useQueue = useQueue({
    initialValues: [],
    limit
  }),
      state = _useQueue.state,
      queue = _useQueue.queue,
      update = _useQueue.update,
      cleanQueue = _useQueue.cleanQueue;

  var showNotification = function showNotification(notification) {
    var id = notification.id || randomId();
    update(function (notifications) {
      if (notification.id && notifications.some(function (n) {
        return n.id === notification.id;
      })) {
        return notifications;
      }

      return [].concat(_toConsumableArray(notifications), [__spreadProps(__spreadValues({}, notification), {
        id
      })]);
    });
    return id;
  };

  var updateNotification = function updateNotification(notification) {
    return update(function (notifications) {
      var index = notifications.findIndex(function (n) {
        return n.id === notification.id;
      });

      if (index === -1) {
        return notifications;
      }

      var newNotifications = _toConsumableArray(notifications);

      newNotifications[index] = notification;
      return newNotifications;
    });
  };

  var hideNotification = function hideNotification(id) {
    return update(function (notifications) {
      return notifications.filter(function (notification) {
        if (notification.id === id) {
          typeof notification.onClose === "function" && notification.onClose(notification);
          return false;
        }

        return true;
      });
    });
  };

  var clean = function clean() {
    return update(function () {
      return [];
    });
  };

  return {
    notifications: state,
    queue,
    showNotification,
    updateNotification,
    hideNotification,
    cleanQueue,
    clean
  };
}

export default useNotificationsState;